import { render, staticRenderFns } from "./Info_BiscuitType.vue?vue&type=template&id=44693911&"
import script from "./Info_BiscuitType.vue?vue&type=script&lang=js&"
export * from "./Info_BiscuitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports